import type { RankingEntry } from '../api/ranking';

export interface RankingFilterOptions {
  minScore: number;
  minScoreGap: number;
  alwaysShowTopN: number;
}

// 게임 내 표시 (grave + 추월 토스트) 에 사용할 랭킹을 필터링한다.
// - 점수 오름차순으로 진행하면서 minScore 미만이거나 lastKept + minScoreGap 미만이면 스킵
// - 단 점수 기준 상위 alwaysShowTopN 은 모든 조건 무시하고 항상 포함
export function filterDisplayedRankings(
  entries: ReadonlyArray<RankingEntry>,
  options: RankingFilterOptions,
): RankingEntry[] {
  if (entries.length === 0) return [];
  const { minScore, minScoreGap, alwaysShowTopN } = options;

  const sortedDesc = [...entries].sort((a, b) => b.score - a.score);
  const topThreshold =
    sortedDesc[alwaysShowTopN - 1]?.score ?? Number.POSITIVE_INFINITY;

  const ascending = [...entries].sort((a, b) => a.score - b.score);
  const result: RankingEntry[] = [];
  let lastKept = Number.NEGATIVE_INFINITY;

  for (const entry of ascending) {
    const isTop = entry.score >= topThreshold;
    if (!isTop) {
      if (entry.score < minScore) continue;
      if (entry.score < lastKept + minScoreGap) continue;
    }
    result.push(entry);
    lastKept = entry.score;
  }
  return result;
}
